import { useCurrentRoleStore } from '~/stores/currentRole'
import { useGameProgressStore } from '~/stores/gameProgress'
import { useGamesStore } from '~/stores/games'
import { useSchoolUsersStore } from '~/stores/schoolUsers'
import { useCurriculumReleaseCache } from '~/composables/useCurriculumReleaseCache'

const legacyPrivateStateKeys = [
  'currentRoleStore',
  'gameProgressStore',
  'gamesStore',
  'schoolUsersStore',
]
const legacyPrivateCacheNames = ['api-cache', 'supabase-cache']

/** Clears data that belongs to the previously authenticated account. */
export function usePrivateClientState() {
  const currentRoleStore = useCurrentRoleStore()
  const gameProgressStore = useGameProgressStore()
  const gamesStore = useGamesStore()
  const schoolUsersStore = useSchoolUsersStore()
  const { clear: clearMemberships } = useSchoolMemberships()
  const { clear: clearCurriculumCache } = useCurriculumReleaseCache()
  const localDataCache = useLocalDataCache()

  const clear = async () => {
    currentRoleStore.deleteCurrentRole()
    gameProgressStore.clearProgress()
    gamesStore.clearGames()
    schoolUsersStore.deleteSchoolUsers()
    useState('curriculum-overviews', () => ({})).value = {}
    localDataCache.clear()
    clearMemberships()
    await clearCurriculumCache()

    if (!import.meta.client) return

    legacyPrivateStateKeys.forEach((key) => window.localStorage.removeItem(key))
    if ('caches' in window) {
      await Promise.all(
        legacyPrivateCacheNames.map((cacheName) =>
          window.caches.delete(cacheName),
        ),
      )
    }
    clearNuxtData()
  }

  return { clear }
}
